import { startCase } from 'lodash-es';

/** What the transactions grids read for a general ledger row, which never carries a stored source. */
export const GENERAL_LEDGER_SOURCE = 'generalLedger';

// Words follow the cap table picker (CaptableSourceMap). Keyed lower case with separators as spaces,
// so the api's `Deal Doc` and the cap table sync's `deal-docs` read the same.
const TRANSACTION_SOURCE_LABELS: Record<string, string> = {
  aumni: 'Aumni',
  carta: 'Carta',
  'deal doc': 'Deal Docs',
  'deal docs': 'Deal Docs',
  'general ledger': 'General Ledger',
  kp: 'Snowflake',
  'managed services': 'Managed Services',
  'nabu agent': 'Managed Services',
  none: '',
  snowflake: 'Snowflake',
  user: 'User Created',
};

/**
 * What created a transaction, as a label. A grid keys its filter list and its group rows on the label and
 * then formats that key a second time, so a label this produces passes straight back through; a value the
 * map doesn't know is title-cased rather than dropped.
 */
export function formatTransactionSource(value: unknown): string {
  if (typeof value !== 'string' || value.trim() === '') {
    return '';
  }
  const key = value
    .trim()
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/[\s_-]+/g, ' ')
    .toLowerCase();

  return TRANSACTION_SOURCE_LABELS[key] ?? startCase(value);
}
